import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Login, EmployeeLogin } from '../pages';
import AcceptInvite from '../pages/Auth/AcceptInvite';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import ResetPassword from '../pages/Auth/ResetPassword';
import EmployeeForgotPassword from '../pages/Auth/EmployeeForgotPassword';
import EmployeeResetPassword from '../pages/Auth/EmployeeResetPassword';
import Signup from '../pages/Auth/Signup';
import PublicRoute from './PublicRoute';

interface PublicRoutesProps {
  setIsAuthenticated: (value: boolean) => void;
}

const PublicRoutes: React.FC<PublicRoutesProps> = ({ setIsAuthenticated }) => {
  return (
    <Routes>
      {/* Redirect root to login */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login setIsAuthenticated={setIsAuthenticated} />
          </PublicRoute>
        }
      />
      <Route
        path="/employee-login"
        element={
          <PublicRoute>
            <EmployeeLogin setIsAuthenticated={setIsAuthenticated} />
          </PublicRoute>
        }
      />
      <Route
        path="/accept-invite"
        element={
          <PublicRoute>
            <AcceptInvite setIsAuthenticated={setIsAuthenticated} />
          </PublicRoute>
        }
      />

      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/reset-password"
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/employee-forgot-password"
        element={
          <PublicRoute>
            <EmployeeForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/employee-reset-password"
        element={
          <PublicRoute>
            <EmployeeResetPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicRoute>
            <Signup />
          </PublicRoute>
        }
      />

      {/* Catch-all: send any other path (e.g., stale /seasons) to login after logout */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default PublicRoutes;
